import React from 'react';
import { TextVariant } from '@naf/text';
import { Button } from '@naf-simba/elements-buttons';
import { Info } from '@styled-icons/material-outlined/Info';
import { CenterProducts, DisplayStyle } from '@appTypes/centerArticleType';
import { useTrackCTA } from '@utils/Tracking/CtaClick/TrackCtaClick';
import { getLabelVariant } from '@lib/getLabelVariant';
import * as S from './ProductPair.styles';

export const ProductPairBlock = ({ products }: { products: CenterProducts[] }) => {
  const trackCTA = useTrackCTA();

  return (
    <S.ProductPairCol s="12" m="12" l="12" xl="12">
      {products.map((product) => {
        const borderLabelVariant = product.displayStyle === DisplayStyle.WithPricePrimaryButton ? 'moss' : 'spruce';
        const borderTagVariant = getLabelVariant(borderLabelVariant);

        return (
          <S.ProductPairBlock key={product.name}>
            <S.Content $displayStyle={product.displayStyle}>
              {product.borderTag && (
                <S.StyledBorderTag
                  text={product.borderTag}
                  color={borderTagVariant.color}
                  shade={borderTagVariant.shade}
                />
              )}
              <S.StyledTitle variant={TextVariant.Header2}>{product.name}</S.StyledTitle>
              {((product.memberPrice && product.memberPrice.isCampaign) ||
                (product.nonMemberPrice && product.nonMemberPrice.isCampaign)) && (
                <S.StyledTag color="secondary" shade="light" text="Kampanje" />
              )}
              {product.memberPrice && (
                <S.TextWrapper>
                  <S.InlineText>
                    Medlemspris: {product.memberPrice.campaignPrice || product.memberPrice.price},-
                  </S.InlineText>
                  {product.memberPrice.campaignPrice && (
                    <S.InlineText>{` (Før: ${product.memberPrice.price},-)`}</S.InlineText>
                  )}
                </S.TextWrapper>
              )}
              {product.nonMemberPrice && (
                <S.TextWrapper>
                  <S.InlineText>
                    Ikke medlem: {product.nonMemberPrice.campaignPrice || product.nonMemberPrice.price},-
                  </S.InlineText>
                  {product.nonMemberPrice.campaignPrice && (
                    <S.InlineText>{` (Før: ${product.nonMemberPrice.price},-)`}</S.InlineText>
                  )}
                </S.TextWrapper>
              )}
              {product.ingress && (
                <>
                  <Info size={24} />
                  <S.Ingress>{product.ingress}</S.Ingress>
                </>
              )}
              {product.booking && product.booking.data.href && product.booking.type === 'externalLink' && (
                <S.ButtonWrapper>
                  <Button
                    color={product.displayStyle === DisplayStyle.WithPricePrimaryButton ? 'primary' : 'secondary'}
                    // Check it, Magnus!
                    // shade={product.displayStyle === DisplayStyle.WithPricePrimaryButton ? undefined : 'light'}
                    href={product.booking.data.href}
                    onClick={() =>
                      product?.booking?.data.href &&
                      trackCTA({
                        cta_position: 'content',
                        text: 'Finn ledig tid',
                        url: product.booking.data.href,
                        cta_hostname: new URL(product.booking.data.href).hostname,
                      })
                    }
                    target={product.booking.data.blank ? '_blank' : '_self'}
                  >
                    Finn ledig tid
                  </Button>
                </S.ButtonWrapper>
              )}
            </S.Content>
          </S.ProductPairBlock>
        );
      })}
    </S.ProductPairCol>
  );
};
